export default class IAPFB {
    constructor() {
        this.onBuy = function () { };
    }
    init() {
        if (typeof (FBInstant) === "undefined") return Promise.resolve();
        return new Promise((resolve, reject) => {
            FBInstant.payments.onReady(function () {
                resolve();
            });
        });
    }

    getCatalog() {
        if (typeof (FBInstant) === "undefined") return Promise.resolve([]);
        return new Promise((resolve, reject) => {
            FBInstant.payments.onReady(function () {
                FBInstant.payments.getCatalogAsync().then(function (catalog) {
                    let items = catalog.map((i) => {
                        return {
                            productId: i.productID,
                            title: i.title,
                            description: i.description,
                            price: i.price,
                            owned: false,
                            canPurchase: true
                        };
                    });
                    //return items; // [{productID: '12345', ...}, ...]
                    resolve(items);
                });
            });
        });
    }
    buy(id) {
        if (typeof (FBInstant) === "undefined") return Promise.resolve();
        return FBInstant.payments.purchaseAsync({
            productID: id,
            developerPayload: '123',
        }).then((purchase) => {
            let productID = purchase.productID;
            let purchaseToken = purchase.purchaseToken;
            //trigger onBuy event
            if (this.onBuy) this.onBuy(productID);

            //consume
            this.consume(productID,purchaseToken);

            return productID;
            // {productID: '12345', purchaseToken: '54321', developerPayload: 'foobar', ...}
        }).catch((error) => {
            let errorMessage = error;
            if (error.message) errorMessage = error.message
            // Handle error
            console.log("FBInstant.payments.purchaseAsync", errorMessage);
        });
    }
    consume(productId,purchaseToken) {
        if (!productId) return Promise.resolve();
        if (typeof (FBInstant) === "undefined") return Promise.resolve();
        //non-consumable
        if (productId.includes('removeads')) return Promise.resolve();
        return FBInstant.payments.consumePurchaseAsync(purchaseToken).then(function () {
            // Purchase successfully consumed!
            // Game should now provision the product to the player
            console.log("FBInstant.payments.consumePurchaseAsync");
        }).catch(function (error) {
            console.log("FBInstant.payments.consumePurchaseAsync Error", error);
        });

    }
    restore() {
        return this.getPurchases().then(items => {
            if (!items) return [];
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (this.onBuy) this.onBuy(item.productId);
                this.consume(item.productId,item.purchaseToken);
            }
            return items;
        });;
    }
    getPurchases() {
        if (typeof (FBInstant) === "undefined") return Promise.resolve();
        return new Promise((resolve, reject) => {
            FBInstant.payments.onReady(() => {
                FBInstant.payments.getPurchasesAsync().then((purchases) => {
                    let items = purchases.map((i) => {
                        return {
                            productId: i.productID,
                            title: i.title,
                            description: i.description,
                            price: i.price,
                            purchaseToken : i.purchaseToken
                        };
                    });
                    resolve(items); // [{productID: '12345', ...}, ...]
                });
            });
        });
    }
}